import { useApplicationCache } from '../../../queries/useApplicationCache';

/**
 * Reads the list of property GUIDs from the React Query application cache.
 */
export function usePropertyGuidsCache(): string[] {
    return useApplicationCache(d =>
        d.information?.properties?.items?.map(p => p.guid) ?? []
    ) ?? [];
}
